import React, { useState } from "react";
import { useSelector } from 'react-redux';
import ProfileMain from "./ProfileMain";
import ProfileDetail from "./ProfileDetail";

const Profile = () => {
    const profileTypesLoading = useSelector(state => state.profileTypes.loading);
    const [isDetailShow, setIsDetailShow] = useState(false);
    const [selectedClientId, setSelectedClientId] = useState(null);


    const onProfileClick = (clientDeviceId) => {
        if (clientDeviceId) {
            setSelectedClientId(clientDeviceId)
        }
        toggleDetailPage()
    }

    const toggleDetailPage = () => {
        if (!profileTypesLoading) {
        setIsDetailShow(!isDetailShow);
        }
      };

      document.title = "AIMEE - User Analytics";
    return (
        <React.Fragment>

                {isDetailShow ? (
                    <ProfileDetail selectedClientId={selectedClientId } onBack={toggleDetailPage}/>
                )
                : (
                    <ProfileMain onProfileClick={onProfileClick} />
                )}

        </React.Fragment>
    );
};

export default Profile;
